import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Redirect } from "react-router";
import { Scrollbars } from "react-custom-scrollbars";

import Aux from "../Aux";
import PageHeader from "../../components/PageHeader";
import FormWrapper from "../../components/FormWrapper";
import FlexWrapper from "../../components/FlexWrapper";
import EditSideColumn from "./components/EditSideColumn";

import { getUserGroups, createUser } from "../../store/Users/services";
import { clearUser } from "../../store/Users/actions";

import Form from "./Form";
import { validateUser } from "../../utils/UserPermissions";

class Create extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requiredPermissions: ["CREATE_USERS", "ALL"]
    };
  }

  submit = values => {
    this.props.dispatch(createUser(values));
  };

  componentWillMount() {
    validateUser(this.props.permissions, this.state.requiredPermissions);
    this.props.dispatch(clearUser());
    this.props.dispatch(getUserGroups());
  }

  render() {
    if (this.props.success) {
      // Redirect when entry created
      return <Redirect to="/users" />;
    }

    return (
      <Aux>
        <PageHeader title="Create User" />
        <FlexWrapper>
          <FormWrapper>
            <Scrollbars>
              <Form
                onSubmit={this.submit}
                mode="create"
                userGroups={this.props.groups}
                enableReinitialize={true}
              />
            </Scrollbars>
          </FormWrapper>
          <EditSideColumn
            submit={this.submit}
            mode="create"
            permissions={this.props.permissions}
          />
        </FlexWrapper>
      </Aux>
    );
  }
}

function mapStateToProps(store) {
  return {
    error: store.user.error,
    success: store.user.success,
    groups: store.user.groups,
    groupsLoading: store.user.groupsLoading,
    loading: store.user.isLoading,
    permissions: store.auth.permissions
  };
}

export default withRouter(connect(mapStateToProps)(Create));



// WEBPACK FOOTER //
// ./src/system/containers/Users/Create.jsx